import {
  CHECK_CALLS_STATUS,
  CHECK_DELIVERED_BOOKINGS,
  CHECK_DELIVERED_SERVICES,
  CHECK_FOR_NEW_AVAILABLE_VERSION,
  CHECK_NOTIFICATIONS,
  DISCARD_EXPIRED_NOT_DELIVERED_NOTIFICATIONS,
  FETCH_BOOKINGS,
  FETCH_HISTORIC_TRIPS,
  FETCH_LIVE_SERVICES,
} from "@/events/constants";

let timers = [];

const scheduledEvents = [
  {
    initial: true,
    interval: 5000,
    event: FETCH_LIVE_SERVICES,
  },
  {
    initial: true,
    interval: 10000,
    event: FETCH_BOOKINGS,
  },
  {
    initial: true,
    interval: 10000,
    event: FETCH_HISTORIC_TRIPS,
  },
  {
    interval: 5000,
    event: CHECK_DELIVERED_BOOKINGS,
  },
  {
    interval: 5000,
    event: CHECK_DELIVERED_SERVICES,
  },
  {
    initial: true,
    interval: 10000,
    event: DISCARD_EXPIRED_NOT_DELIVERED_NOTIFICATIONS,
  },
  {
    initial: true,
    interval: 60000,
    event: CHECK_FOR_NEW_AVAILABLE_VERSION,
  },
  {
    initial: true,
    interval: 5500,
    event: CHECK_NOTIFICATIONS,
  },
  {
    initial: true,
    interval: 2000,
    event: CHECK_CALLS_STATUS,
  },
];

export function register() {
  if (timers.length > 0) {
    destroy();
  }
  timers.push(
    ...scheduledEvents.map(({ initial, event, interval }) => {
      initial && window.$bus.emit(event);
      return setInterval(() => window.$bus.emit(event), interval);
    })
  );
}

export function destroy() {
  timers.forEach((t) => clearInterval(t));
  timers = [];
}
